/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface RefinementCriterionField
 */
export interface RefinementCriterionField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof RefinementCriterionField
     */
    criterion: string;
    /**
     * 
     * @type {number}
     * @memberof RefinementCriterionField
     */
    index: number;
}

/**
 * Check if a given object implements the RefinementCriterionField interface.
 */
export function instanceOfRefinementCriterionField(value: object): value is RefinementCriterionField {
    if (!('criterion' in value) || value['criterion'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    return true;
}

export function RefinementCriterionFieldFromJSON(json: any): RefinementCriterionField {
    return RefinementCriterionFieldFromJSONTyped(json, false);
}

export function RefinementCriterionFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefinementCriterionField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'criterion': json['criterion'],
        'index': json['index'],
    };
}

export function RefinementCriterionFieldToJSON(value?: RefinementCriterionField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'criterion': value['criterion'],
        'index': value['index'],
    };
}

